/** @deprecated */
export const validator = {
  required: (value) => (value && !value.match(/^\s*$/) ? undefined : 'form.requiredField'),
  email: (value) =>
    value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,20}$/i.test(value.trim()) ? 'validations.emailInvalid' : undefined,
  checkboxValidation: (val) => (val ? undefined : true),
  resetInput: (val) => (val && val.toLowerCase() !== 'reset' ? 'form.validations.resetInput' : undefined),
};
